module.exports = __webpack_public_path__ + "img/realtime_subtitles.7a9750d2.png";